import { Navbar } from "flowbite-react";
import { getSiteContent, localeRoutes } from "../i18n/siteContent";

function Nav({ locale = "en" }) {
    const site = getSiteContent(locale);
    const routes = localeRoutes[locale];
    const switchTo = locale === "en" ? localeRoutes.it.home : localeRoutes.en.home;

    return (
        <div className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
            <Navbar fluid rounded={false} className="mx-auto max-w-6xl bg-transparent px-4 py-3 sm:px-6">
                <Navbar.Brand href={routes.home}>
                    <span className="font-impact text-3xl">Maurizio Brioschi</span>
                </Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse>
                    <Navbar.Link href={routes.home}>{site.nav.home}</Navbar.Link>
                    <Navbar.Link href={routes.services}>{site.nav.services}</Navbar.Link>
                    <Navbar.Link href={routes.caseStudies}>{site.nav.caseStudies}</Navbar.Link>
                    <Navbar.Link href={routes.about}>{site.nav.about}</Navbar.Link>
                    <Navbar.Link href={routes.contact}>{site.nav.contact}</Navbar.Link>
                    <a
                        href={routes.contact}
                        className="inline-flex items-center rounded-full bg-slate-900 px-4 py-2 text-xs font-semibold text-white transition hover:bg-slate-700 md:ml-2"
                    >
                        {site.nav.cta}
                    </a>
                    <a
                        href={switchTo}
                        className="inline-flex items-center rounded-full border border-slate-300 px-3 py-1 text-xs font-semibold text-slate-700 transition hover:bg-slate-100 md:ml-3"
                    >
                        {site.nav.switchLabel}
                    </a>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default Nav;
